import { render, staticRenderFns } from "./VueButton.vue?vue&type=template&id=64baa03d&scoped=true&"
import script from "./VueButton.vue?vue&type=script&lang=js&"
export * from "./VueButton.vue?vue&type=script&lang=js&"
import style0 from "./VueButton.vue?vue&type=style&index=0&id=64baa03d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64baa03d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64baa03d')) {
      api.createRecord('64baa03d', component.options)
    } else {
      api.reload('64baa03d', component.options)
    }
    module.hot.accept("./VueButton.vue?vue&type=template&id=64baa03d&scoped=true&", function () {
      api.rerender('64baa03d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/VueButton.vue"
export default component.exports